import { gql } from "@apollo/client";

export const BENEFICIARY_GIFTING_LINK = gql`
  query beneficiaryGiftingLink($beneficiaryId: String!) {
    beneficiaryGiftingLink(beneficiaryId: $beneficiaryId) {
      giftingUrl
      giftingCode
      isGiftingCodeConfirmed
    }
  }
`;

export const CHECK_GIFTING_CODE_AVAILABILITY = gql`
  query checkGiftingCodeAvailability($giftingCode: String!, $beneficiaryId: String!) {
    checkGiftingCodeAvailability(
      input: { giftingCode: $giftingCode, beneficiaryId: $beneficiaryId }
    ) {
      isAvailable
    }
  }
`;
